import React from "react"; 

// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";

import axios from 'axios'
import style from './styles.module.css'
import Button from '@material-ui/core/Button'
import ConfSeries from './confSeries/ConfSeries'
import IconButton from '@material-ui/core/IconButton'
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import Snackbar from '../utils/snackbar/Snackbar'
import {withRouter} from 'react-router-dom' 
import CircularProgress from '@material-ui/core/CircularProgress'
import TopBar from "../utils/Topbar/TopBar.js";
import {connect} from 'react-redux'
import {getSeries} from '../../containers/app/actions'
import SplitButton from "../utils/SplitButton/SplitButton.js";
import ConfirmAlert from "../utils/ConfirmAlert/ConfirmAlert.js";

const Series = (props) => { 
  const [data,setData] = React.useState(false)
  const [filteredData,setFilteredData] = React.useState(false)
  const [searchValue,setSearchValue] = React.useState("")

  const [alert,setAlert] = React.useState(false);
  const [addModal,setAddModal] = React.useState(false);
  const [editModal,setEditModal] = React.useState(false);
  const [activeSeries,setSeries] = React.useState(false) 

  React.useEffect(() => {
    props.getSeries(props.user._id)
  },[]);


  React.useEffect(() => {
    if(props.series) {
      let arr = [];
      arr = props.series.filter(val => {
        if(val.seriesName.toLowerCase().includes(searchValue.toLowerCase()) || val.status.toLowerCase().includes(searchValue.toLowerCase())) {
          return val;
        }
      }) 
      setFilteredData(arr);
    } else {
      setFilteredData(false)
    }
  },[searchValue,props.series]);



  const handleDelete = (value) => {
    axios({
      method: "post",
      url: "/deleteSeries",
      data: {
        seriesId: value._id,
      }
    }).then(res => {
      setAlert("Deleted Successfully")
      props.getSeries(props.user._id);
    }).catch(err => {
      setAlert("Something went wrong");

      console.log(err)
    })
  }

  const isLoading = !filteredData;
  const showData = !isLoading;
  const details = [];

  
  !isLoading && filteredData.forEach((val,index) => {
    details.push(
      [
        index + 1,
        val.seriesName,
        val.series_barcode,
        val.status, 
        <React.Fragment>  
          <IconButton onClick={() => {
            setSeries(val)
            setEditModal(true)
          }}>
            <EditRoundedIcon />
          </IconButton>
          
          <ConfirmAlert msg={`Are you sure you want delete ?`} onClickEvent={() => handleDelete(val)}> 
            <IconButton>
              <DeleteRoundedIcon />
            </IconButton>
          </ConfirmAlert>
        </React.Fragment>
      ]
    )
  });


  return (
    <GridContainer>
      
      {addModal && <ConfSeries
        type="ADD" 
        open={addModal} 
        onClose={() => setAddModal(false)} 
        onDone={() => {
          setAddModal(false)
          props.getSeries(props.user._id)
        }}
        setAlert={(msg) => setAlert(msg)}
      />}
      {activeSeries && <ConfSeries 
        type="EDIT"
        series={activeSeries} 
        open={editModal} 
        onClose={() => setEditModal(false)} 
        onDone={() => {
          setEditModal(false)
          setSeries(false)
          props.getSeries(props.user._id)
        }} 
        setAlert={(msg) => setAlert(msg)}
      />} 
 
      <Snackbar open={alert} handleClose={() => setAlert(false)}/>
 
      <TopBar 
        searchValue={searchValue} 
        onSearchChange={(value) => setSearchValue(value)}  

        nav={[
          {Name: "Products",onClick: () => props.history.push("/admin/product")},
          {Name: "Series",onClick: () => {}}
        ]}
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Series</h4> 

              <div className={style.buttons}> 
                <Button color="secondary" variant="contained" onClick={() => setAddModal(true)}>Add Series</Button>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading &&
              <div className={style.loader}>
                <CircularProgress />
              </div>
            }
            
            {showData && 
              <Table
                tableHeaderColor="primary"
                tableHead={["Sl No", "Series Name", "barcode", "Status","Action"]}
                tableData={details}
              />}
          </CardBody>
        </Card>
      </GridItem> 
    </GridContainer>
  );
}

const mapStateToProps = state => ({
  user: state.appReducer.user,
  series: state.appReducer.series
})
export default withRouter(connect(mapStateToProps,{getSeries})(Series));